import { decodeReport } from 'models/Candidate/Report';
import { ServerApi } from 'modules/api/server-api';

export const fetchCandidateReport = (api: ServerApi) => async () => {
  const response = await api.get('/v3/candidate/search-session/report');
  return decodeReport(response.data);
};
